import { createAction } from "redux-actions";

const ACTION_TYPE = "SUBSCRIPTIONS";

export const fetchSubscriptions = createAction(`${ACTION_TYPE}/FETCH`);
export const fetchSubscriptionsSuccess = createAction(`${ACTION_TYPE}/FETCH_SUCCESS`);
export const fetchSubscriptionFailure = createAction(`${ACTION_TYPE}/FETCH_FAILURE`);
